import {PermissionCheckerService} from 'abp-ng2-module';
import {AppSessionService} from '@shared/common/session/app-session.service';

import {Injectable} from '@angular/core';
import {AppMenu} from './app-menu';
import {AppMenuItem} from './app-menu-item';
import { AppConsts } from '@shared/AppConsts';
import { CodeService } from '@app/shared/common/code/code.service';
import { CodeCategory } from '@shared/service-proxies/service-proxies';

@Injectable()
export class AppNavigationService {

    constructor(
        private _permissionCheckerService: PermissionCheckerService,
        private _appSessionService: AppSessionService,
        private _codeService: CodeService
    ) {

    }

    getMenu(): AppMenu {

        let sqlQueryAppMenuItem = this.createSqlQueryMenuItem();

        return new AppMenu('MainMenu', 'MainMenu', [
            new AppMenuItem('MySirona', 'Pages.Applicant.Services', 'flaticon-home', AppConsts.applicantStartUrl),
            new AppMenuItem('Dashboard', 'Pages.Authority.Dashboard', 'flaticon-squares', '/app/authority/dashboard', undefined, undefined, undefined, undefined, () => abp.features.isEnabled(AppConsts.features.dashboard)),
            new AppMenuItem('Documents', 'Pages.Authority.DocumentManagementSystem', 'flaticon-squares', '/app/authority/documents'),
            new AppMenuItem('Pendences', 'Pages.Authority.Pendences', 'flaticon-squares', '/app/authority/pendences', undefined, undefined, undefined, undefined),
            new AppMenuItem('Dossier', 'Pages.Authority',  'flaticon-squares', '', [], [
                new AppMenuItem('People', 'Pages.Authority.PersonDossier', 'flaticon-squares', '/app/authority/person-dossier', undefined, undefined, undefined, undefined, () => abp.features.isEnabled(AppConsts.features.personDossier)),
                new AppMenuItem('Businesses', 'Pages.Authority.Business', 'flaticon-squares', '/app/authority/business-dossier', undefined, undefined, undefined, undefined, () => abp.features.isEnabled(AppConsts.features.personDossier)),
                new AppMenuItem('Sponsorships', 'Pages.Authority.SponsorshipDossier', 'flaticon-squares', '/app/authority/sponsorship-dossier', undefined, undefined, undefined, undefined, () => abp.features.isEnabled(AppConsts.features.sponsorshipDossier)),
            ]),
            new AppMenuItem('Applications', 'Pages.Authority.Applications', 'flaticon-squares', '', [], [
                new AppMenuItem('People', 'Pages.Authority.Applications', 'flaticon-download', AppConsts.authorityBaseUrl + '/applications/person'),
                new AppMenuItem('Sponsorships', 'Pages.Authority.Applications', 'flaticon-download', AppConsts.authorityBaseUrl + '/applications/sponsorship'),
                new AppMenuItem('Mutationen', 'Pages.Authority.Applications', 'flaticon-download', AppConsts.authorityBaseUrl + '/applications/mutation'),
                new AppMenuItem('EhcCapWaitlist', 'Pages.Administration.EhcCapRegulation', 'flaticon-download', AppConsts.authorityBaseUrl + '/applications/ehc-cap-waitlist'),
                new AppMenuItem('Legitimation', 'Pages.Authority.Applications', 'flaticon-download', AppConsts.authorityBaseUrl + '/applications/legitimations'),
            ]),
            sqlQueryAppMenuItem,
            new AppMenuItem('Dashboard', 'Pages.Administration.Host.Dashboard', 'flaticon-line-graph', '/app/admin/hostDashboard'),
            new AppMenuItem('Dashboard', 'Pages.Tenant.Dashboard', 'flaticon-line-graph', '/app/main/dashboard'),
            new AppMenuItem('Tenants', 'Pages.Tenants', 'flaticon-list-3', '/app/admin/tenants'),
            new AppMenuItem('Editions', 'Pages.Editions', 'flaticon-app', '/app/admin/editions'),
            new AppMenuItem('NavigationInvoices', 'Pages.Authority.Invoices', 'flaticon-app', '/app/authority/invoices'),
            new AppMenuItem('Administration', '', 'flaticon-interface-8', '', [], [
                new AppMenuItem('OrganizationUnits', 'Pages.Administration.OrganizationUnits', 'flaticon-map', '/app/admin/organization-units'),
                new AppMenuItem('Roles', 'Pages.Administration.Roles', 'flaticon-suitcase', '/app/admin/roles'),
                new AppMenuItem('Users', 'Pages.Administration.Users', 'flaticon-users', '/app/admin/users'),
                new AppMenuItem('MailDistributionLists', 'Pages.Administration.OrganizationUnits', 'flaticon-map', '/app/admin/mail-distribution'),
                new AppMenuItem('Codes', 'Pages.Administration.Codes', 'flaticon-list-2', '/app/admin/codes'),
                new AppMenuItem('Languages', 'Pages.Administration.Languages', 'flaticon-tabs', '/app/admin/languages', ['/app/admin/languages/{name}/texts']),
                new AppMenuItem('AuditLogs', 'Pages.Administration.AuditLogs', 'flaticon-folder-1', '/app/admin/auditLogs'),
                new AppMenuItem('Maintenance', 'Pages.Administration.Host.Maintenance', 'flaticon-lock', '/app/admin/maintenance'),
                new AppMenuItem('VisualSettings', 'Pages.Administration.UiCustomization', 'flaticon-medical', '/app/admin/ui-customization'),
                new AppMenuItem('Settings', 'Pages.Administration.Host.Settings', 'flaticon-settings', '/app/admin/hostSettings'),
                new AppMenuItem('TenantSettings', 'Pages.Administration.Tenant.Settings', 'flaticon-settings', '/app/admin/tenantSettings'),
                new AppMenuItem('SironaSettings', 'Pages.Administration.SironaSettings', 'flaticon-settings', '/app/admin/sirona-settings'),
                new AppMenuItem('ProfessionConfiguration', 'Pages.Administration.ProfessionConfiguration', 'flaticon-settings', '/app/admin/profession-configuration'),
                new AppMenuItem('SponsorshipTypeConfiguration', 'Pages.Administration.SponsorshipTypeConfiguration', 'flaticon-settings', '/app/admin/sponsorship-type-configuration'),
                new AppMenuItem('DmsAdministration', 'Pages.Administration.Dms', 'flaticon-settings', '/app/admin/dms-administration'),
                new AppMenuItem('SqlQueries', 'Pages.Administration.SqlQuery', 'flaticon-settings', '/app/admin/sql-queries'),
                new AppMenuItem('InvoiceAdministration', 'Pages.Administration.Invoice', 'flaticon-settings', '/app/admin/invoice-admin'),
                new AppMenuItem('EhcCapRegulation', 'Pages.Administration.EhcCapRegulation', 'flaticon-settings', '/app/admin/ehc-cap-regulation'),
            ])
        ]);
    }

    private createSqlQueryMenuItem(): AppMenuItem {
        const queryCategories = this._codeService.getCodesSync(CodeCategory.SqlQueryCategory).filter(x => x.isActive);

        const childs = queryCategories.map(x =>
            new AppMenuItem(x.id, 'Pages.Authority.SqlQuery', 'flaticon-squares', `${AppConsts.authorityBaseUrl}/sql-queries/${x.id}`));
        return new AppMenuItem('SqlQueries', 'Pages.Authority.SqlQuery', 'flaticon-squared', '', [], childs);
    }

    checkChildMenuItemPermission(menuItem): boolean {

        for (let i = 0; i < menuItem.items.length; i++) {
            let subMenuItem = menuItem.items[i];

            if (subMenuItem.permissionName === '' || subMenuItem.permissionName === null) {
                if (subMenuItem.route) {
                    return true;
                }
            } else if (this._permissionCheckerService.isGranted(subMenuItem.permissionName)) {
                return true;
            }

            if (subMenuItem.items && subMenuItem.items.length) {
                let isAnyChildItemActive = this.checkChildMenuItemPermission(subMenuItem);
                if (isAnyChildItemActive) {
                    return true;
                }
            }
        }
        return false;
    }

    showMenuItem(menuItem: AppMenuItem): boolean {
        if (menuItem.permissionName === 'Pages.Administration.Tenant.SubscriptionManagement' && this._appSessionService.tenant && !this._appSessionService.tenant.edition) {
            return false;
        }

        let hideMenuItem = false;

        if (menuItem.requiresAuthentication && !this._appSessionService.user) {
            hideMenuItem = true;
        }

        if (menuItem.permissionName && !this._permissionCheckerService.isGranted(menuItem.permissionName)) {
            hideMenuItem = true;
        }

        if (this._appSessionService.tenant || !abp.multiTenancy.ignoreFeatureCheckForHostUsers) {
            if (menuItem.hasFeatureDependency() && !menuItem.featureDependencySatisfied()) {
                hideMenuItem = true;
            }
        }

        if (!hideMenuItem && menuItem.items && menuItem.items.length) {
            return this.checkChildMenuItemPermission(menuItem);
        }

        return !hideMenuItem;
    }

    /**
     * Returns all menu items recursively
     */
    getAllMenuItems(): AppMenuItem[] {
        let menu = this.getMenu();
        let allMenuItems: AppMenuItem[] = [];
        menu.items.forEach(menuItem => {
            allMenuItems = allMenuItems.concat(this.getAllMenuItemsRecursive(menuItem));
        });

        return allMenuItems;
    }

    private getAllMenuItemsRecursive(menuItem: AppMenuItem): AppMenuItem[] {
        if (!menuItem.items) {
            return [menuItem];
        }

        let menuItems = [menuItem];
        menuItem.items.forEach(subMenu => {
            menuItems = menuItems.concat(this.getAllMenuItemsRecursive(subMenu));
        });

        return menuItems;
    }
}
